import React from 'react';
import { useT } from '@repo/common';

const SearchNotFound = () => {
  const t = useT();
  return (
    <div className='flex flex-col justify-center items-center text-center pt-[60px] tabletH:pt-10 pb-[120px] tabletV:pb-[120px] w-full max-w-[290px] mx-auto'>
      <div className='flex flex-col items-center p-0 gap-0.5 tabletH:gap-[6px]'>
        <div className='typo-b16Strong tabletH:typo-title3 text-text-placeholder'>
          {t('No search results', '검색 결과가 없습니다')}
        </div>
        <div className='typo-b12 tabletH:typo-b14 text-text-placeholder'>
          {t(
            'Try changing your search terms or location to find matching jobs',
            '검색어나 지역을 변경해 일치하는 채용 공고를 찾아보세요',
          )}
        </div>
      </div>
    </div>
  );
};

export default SearchNotFound;
